import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";

import authSlice from "./auth-slice";
import buildingSlice from "./building-slice";
import connectivitySlice from "./connectivity-slice";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    buildingList: buildingSlice.reducer,
    connectivity: connectivitySlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
